import { render, staticRenderFns } from "./YoshlarSiyosati.vue?vue&type=template&id=298d0f00&scoped=true&"
import script from "./YoshlarSiyosati.vue?vue&type=script&lang=js&"
export * from "./YoshlarSiyosati.vue?vue&type=script&lang=js&"
import style0 from "./YoshlarSiyosati.vue?vue&type=style&index=0&id=298d0f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298d0f00",
  null
  
)

export default component.exports